<template>
  <div class="my-pooq-view-wrapper">
    <div class="sticky-area" v-if="device === 'mobile'">
      <common-header title="약관 및 정책" :back-fn="close" :is-back-btn="true" :is-close-btn="false"></common-header>
      <!-- 마이페이지 gnb 메뉴 -->
      <common-main-menu :menu-items="menuItems" :menu-index="mainMenuIndex" :change-menu-fn="changeMainMenu" />
    </div>
    <div :class="getWrapperClass" data-scroll-element="true">
      <router-view name="agreementView" :key="'agreement_' + $route.name"></router-view>
    </div>
  </div>

</template>

<script>
import { get } from 'lodash'
import CommonMainMenu from '@/components/lnb/mypooq/CommonMainMenu'
import VueSticky from 'vue-sticky'
import { mapGetters } from 'vuex'
import { infiniteScroll } from '@/common/directives'
import { AGREEMENT_MENU_LIST } from '@/common/menu.constant'
import utils from '@/common/util/utils'
import CommonHeader from '@/components/header/template/commonHeader'

export default {
  name: 'MyPooqView',
  components: {
    CommonHeader,
    CommonMainMenu
  },
  directives: {
    VueSticky,
    infiniteScroll
  },
  data () {
    return {
      mainMenuIndex: 0,
      menuItems: AGREEMENT_MENU_LIST,
      device: utils.cookies.getDevice()
    }
  },
  computed: {
    ...mapGetters(['getBeforePathOpenMyPooq']),
    getWrapperClass () {
      let defaultClass = 'my-wrap'
      if (this.device !== 'mobile') {
        defaultClass += ' not-mobile'
      }
      return defaultClass
    }
  },
  methods: {
    close () {
      const referer = get(this.$route, 'query.referer', '')
      if (referer === '') {
        this.$router.replace('/')
      } else {
        const decodedURL = decodeURIComponent(referer)
        const hasProtocol = decodedURL.indexOf('http://') > -1 || decodedURL.indexOf('https://') > -1
        if (hasProtocol) {
          location.replace(referer)
        } else {
          this.$router.replace(referer)
        }
      }
    },
    changeMainMenu (mainMenuObject) {
      this.mainMenuIndex = mainMenuObject.index
      const referer = get(this.$route, 'query.referer', '')
      const targetPath = referer === '' ? mainMenuObject.path : mainMenuObject.path + '?referer=' + referer
      this.$router.push(targetPath)
    }
  },
  created () {
    const lastPath = this.$route.name
    if (lastPath === 'agreement') {
      this.$router.replace('/agreement/service')
    }
    switch (lastPath) {
      case 'service':
        this.mainMenuIndex = 0
        break
      case 'paid':
        this.mainMenuIndex = 1
        break
      case 'privacy':
        this.mainMenuIndex = 2
        break
      case 'youth':
        this.mainMenuIndex = 3
        break
      case 'pooqzone_voucher':
        this.mainMenuIndex = 4
        break
      case 'pooqzone_privacy':
        this.mainMenuIndex = 5
        break
    }
  }
}
</script>

<style scoped>
  .my-pooq-content-body {
    position: relative;
    width: 100%;
  }
  .my-pooq-content-body::-webkit-scrollbar{
    display: none
  }
  .my-wrap {
    width: 100%;
    height: 100%;
    padding-bottom: 0;
  }
  .my-wrap.not-mobile {
    padding-top: 0 !important;
  }
</style>
